import { defineRecipe } from '@chakra-ui/react'

export const badgeRecipe = defineRecipe({
  className: 'chakra-badge',
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: 'l2',
    gap: '1',
    paddingX: '1',
    fontWeight: 'medium',
    fontVariantNumeric: 'tabular-nums',
    whiteSpace: 'nowrap',
    userSelect: 'none',
  },
  variants: {
    variant: {
      count: {
        bgColor: 'red.600',
        borderRadius: 'full',
        borderTop: '0.5px solid rgba(255,255,255,.25)',
        boxShadow: 'xs',
        color: 'white',
        display: 'inline-block',
        fontWeight: 'semibold',
        fontFamily: 'Poppins, sans-serif',
        fontSize: '11px',
        lineHeight: '1',
        minHeight: '1em',
        minWidth: '2em',
        padding: '0.2em 0.5em',
        textAlign: 'center',
        textShadow: '0 1px 1px rgba(0,0,0,0.5)',
      },
      countGeneric: {
        bgColor: 'colorPalette.solid',
        borderRadius: 'full',
        color: 'white',
        display: 'inline-block',
        fontWeight: 'semibold',
        fontFamily: 'Poppins, sans-serif',
        fontSize: '11px',
        lineHeight: '1',
        minHeight: '1em',
        minWidth: '2em',
        padding: '0.2em 0.5em',
        textAlign: 'center',
        textShadow: '0 1px 1px rgba(0,0,0,0.5)',
      },
      solid: {
        bg: 'colorPalette.solid',
        color: 'colorPalette.contrast',
      },
      subtle: {
        bg: 'colorPalette.subtle',
        color: 'colorPalette.fg',
      },
      outline: {
        color: 'colorPalette.fg',
        '--outline-shadow-legacy': 'colors.colorPalette.muted',
        '--outline-shadow': 'colors.colorPalette.border',
        shadow: 'inset 0 0 0px 1px var(--shadow-color)',
        shadowColor: 'var(--outline-shadow, var(--outline-shadow-legacy))',
      },
      surface: {
        bg: 'colorPalette.subtle',
        color: 'colorPalette.fg',
        shadow: 'inset 0 0 0px 1px var(--shadow-color)',
        shadowColor: 'colorPalette.muted',
      },
      plain: {
        color: 'colorPalette.fg',
      },
      label: {
        fontWeight: 'bold',
        textTransform: 'uppercase',
        letterSpacing: 'wider',
        padding: 2,
        // boxShadow: 'xs',
      },
      title: {
        fontWeight: 'bold',
        textTransform: 'uppercase',
        letterSpacing: 'widest',
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
    size: {
      xs: {
        textStyle: '2xs',
        minH: '4',
      },
      sm: {
        textStyle: 'xs',
        minH: '7',
      },
      md: {
        textStyle: 'sm',
        minH: '6',
      },
      lg: {
        textStyle: 'sm',
        minH: '7',
      },
    },
  },
  defaultVariants: {
    variant: 'subtle',
    size: 'sm',
  },
})
